import React from 'react';
import { stats } from '../data/mockData';
import { Button } from './ui/button';

const StatsSection = () => {
  return (
    <section className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Left Image */}
          <div>
            <img
              src="https://customer-assets.emergentagent.com/job_fasttrack-visa/artifacts/x2bfq4a5_faceless_Ultra-realistic_business_meeting_photograph_in_a_mod_1cc113a8-0117-479c-a31d-bcc880b741df_3.png"
              alt="Business meeting"
              className="rounded shadow-lg w-full"
            />
          </div>

          {/* Right Content */}
          <div>
            <h2 className="text-[#1a3a5c] text-3xl font-bold mb-4 uppercase">
              Proven, Trusted & Reliable Visa Experts
            </h2>
            <p className="text-gray-600 mb-8">
              We provide outstanding project opportunities, supported by 30+ years of collective real-estate development, finance and banking executive team experience.
            </p>

            {/* Stats Grid */}
            <div className="grid grid-cols-4 gap-4 mb-8">
              {stats.map((stat, index) => (
                <div key={index} className="text-left">
                  <div className="w-12 h-1 bg-[#c94a4a] mb-2"></div>
                  <div className="text-[#c94a4a] text-2xl md:text-3xl font-bold">
                    {stat.value}
                  </div>
                  <div className="text-gray-600 text-xs md:text-sm">
                    {stat.label}
                  </div>
                </div>
              ))}
            </div>

            <Button
              onClick={() => document.getElementById('hero-form')?.scrollIntoView({ behavior: 'smooth' })}
              variant="outline"
              className="border-[#1a3a5c] text-[#1a3a5c] hover:bg-[#1a3a5c] hover:text-white px-8 py-3 rounded font-medium"
            >
              Discover Why We Are Leaders
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default StatsSection;
